import { MessageCircle } from "lucide-react";
import { useSiteSettings } from "@/lib/siteSettings";
import { track } from "@/lib/analytics";

/** "Questions? Ask us on WhatsApp", shown only once a WhatsApp link is set in Admin > Settings. */
export default function AskWhatsApp({ topic, className = "" }) {
  const url = useSiteSettings()?.whatsapp_url;
  if (!url) return null;
  // wa.me links accept a prefilled message.
  const href = topic && /wa\.me\//.test(url) && !url.includes("?")
    ? `${url}?text=${encodeURIComponent(`Hi Karijeeva, I have a question about ${topic}.`)}`
    : url;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" onClick={() => track("contact_whatsapp", { topic: topic || "general" })}
      className={`inline-flex items-center gap-2 font-body text-[14px] text-brand-ink hover:text-brand-gold ${className}`} data-testid="ask-whatsapp">
      <MessageCircle className="w-4 h-4" /> Questions? Ask us on WhatsApp
    </a>
  );
}
